





































import { Component, Prop, Mixins } from "vue-property-decorator";
import dateRanges from "@/data/dateranges";
import { DataModules } from "@/store/modules/data";
import { IStatRange } from "@/models/stats";
import StatsCurrencyMixin from "@/mixins/statsCurrencyMixin";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import {
  STATS_DEFAULT_CURRENCY_CODE,
  STATS_ALL_CURRENCY_CODE
} from "@/data/constants";

@Component
export default class StatHeader extends Mixins(
  StatsCurrencyMixin,
  StatsStorageMixin
) {
  // Props
  @Prop({ required: true })
  public title!: string;

  @Prop({ required: true })
  public value!: IStatRange;

  @Prop({ default: STATS_DEFAULT_CURRENCY_CODE })
  public currency!: string | null;

  @Prop({ default: false })
  public simple!: boolean;

  @Prop({ default: false })
  public time!: boolean;

  // Data
  public selectedCurrencyCode = this.currency;

  // Lifecycle methods
  public async created() {
    await this.setDefaultCurrency();
    dateRanges.$on("day-changed", this.handleDateChange.bind(this));
  }

  public beforeDestroy() {
    dateRanges.$off();
  }

  public handleDateChange() {
    // Custom dates doesn't have key
    if (!this.value || !this.$_.get(this.value, "key")) return;
    this.onDatesChange(dateRanges.ranges[this.value.key as string]);
  }

  // Getters
  public get showAll() {
    return STATS_ALL_CURRENCY_CODE === this.selectedCurrencyCode;
  }

  public get availableCurrencyCodes() {
    return this.$_.map(this.brandCurrencies, i => i.code);
  }

  public get showCurrencySelect() {
    return this.brandCurrencies.length > 1;
  }

  public get dateRanges() {
    return dateRanges.ranges;
  }

  public get dates() {
    return [this.value.dateFrom, this.value.dateTo];
  }

  public async setDefaultCurrency() {
    const currency = await this.getStatsDefaultCurrencyCode();
    this.selectedCurrencyCode = currency;
    this.onCurrencyChange(currency);
  }

  public onCurrencyChange(currency) {
    this.$emit("update:currency", currency);
  }

  public onDatesChange(statRange: IStatRange) {
    this.$emit("input", statRange);
    this.trySetStatDateToStorage(statRange);
  }

  public openDateRangeModal() {
    this.$store.dispatch(`data/${DataModules.STATS}/openDateRangeModal`, {
      config: {
        props: {
          dateFrom: this.value.dateFrom,
          dateTo: this.value.dateTo,
          time: this.time
        },
        events: {
          update: (result: IStatRange) => {
            this.$emit("input", result);
            this.trySetStatDateToStorage(result);
          }
        }
      }
    });
  }
}
